if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', class DeliveryEstimate extends HTMLElement {
    constructor() {
      super();
      this.days_of_week = window.variantStrings?.days_of_week || [
        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
      ];
      this.weekDays = this.days_of_week.map(d => d.slice(0, 3).toLowerCase());
      this.isActive = false;
      this.lastUpdateTime = 0;
      this.intervalId = null;
    }

    parseWeekdaysToSkip(skipString) {
      if (!skipString) return new Set();
      return new Set(
        skipString.toLowerCase()
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
          .map(d => this.weekDays.indexOf(d))
          .filter(i => i !== -1)
      );
    }

    connectedCallback() {
      this.counterElement = this.querySelector('[data-slot="counter"]');
      this.dateElement = this.querySelector('[data-slot="date"]');

      this.deliveryDays = Number(this.dataset.deliveryDays) || 3;
      this.cutoffHour = Number(this.dataset.cutoffHour) || 12;
      this.dateFormat = this.dataset.dateFormat || 'day, dd/mm/yyyy';
      this.dataTimeFormat = this.dataset.timeFormat || 'full';
      this.weekdaysToSkip = this.parseWeekdaysToSkip(this.dataset.skipWeekdays);

      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
      this.counterElement = null;
      this.dateElement = null;
    }

    startTimer() {
      this.isActive = true;
      this.render();

      this.intervalId = setInterval(() => {
        if (this.isActive) {
          this.render();
        }
      }, 1000);
    }

    stopTimer() {
      this.isActive = false;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    render() {
      if (!this.isActive) return;

      const now = Date.now();

      if (now - this.lastUpdateTime < 1000 && this.cachedData) {
        return;
      }

      const { timeLeft, deliveryDate } = this.calculateDate();
      this.cachedData = { timeLeft, deliveryDate };
      this.lastUpdateTime = now;

      if (this.counterElement) {
        const formattedTime = this.formatTime(timeLeft);
        if (this.counterElement.textContent !== formattedTime) {
          this.counterElement.textContent = formattedTime;
        }
      }

      if (this.dateElement) {
        const formattedDate = this.formatDate(deliveryDate);
        if (this.dateElement.textContent !== formattedDate) {
          this.dateElement.textContent = formattedDate;
        }
      }
    }

    calculateDate() {
      const now = new Date();

      const cutoff = new Date(now);
      cutoff.setHours(this.cutoffHour, 0, 0, 0);
      if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);

      const timeLeft = cutoff - now;

      const deliveryDate = new Date(cutoff);
      let daysAdded = 0;

      while (daysAdded < this.deliveryDays) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        if (!this.weekdaysToSkip.has(deliveryDate.getDay())) {
          daysAdded++;
        }
      }

      return { timeLeft, deliveryDate };
    }

    formatTime(ms) {
      const totalSeconds = Math.floor(ms / 1000);
      if (totalSeconds <= 0) return '0s';

      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;

      const strings = window.variantStrings?.time || {
        hours: 'hours',
        minutes: 'minutes',
        seconds: 'seconds',
        hours_short: 'hr',
        minutes_short: 'min',
        seconds_short: 'sec'
      };

      const useShort = this.dataTimeFormat === 'short';

      let out = [];
      if (h) out.push(`${h}${useShort ? strings.hours_short : ' ' + strings.hours}`);
      if (m) out.push(`${m}${useShort ? strings.minutes_short : ' ' + strings.minutes}`);
      if (!h && !m) {
        out.push(`${s}${useShort ? strings.seconds_short : ' ' + strings.seconds}`);
      }

      return out.join(' ');
    }

    formatDate(d) {
      const weekdayName = this.days_of_week[d.getDay()];
      return this.dateFormat
        .replace('day', weekdayName)
        .replace('dd', String(d.getDate()).padStart(2, '0'))
        .replace('mm', String(d.getMonth() + 1).padStart(2, '0'))
        .replace('yyyy', d.getFullYear())
        .replace('yy', String(d.getFullYear()).slice(-2));
    }
  });
}